import React from "react";
import { Link } from "react-router-dom";  // Import Link from react-router-dom

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <section className="footer-section gridrowfull">
            <div className="footer-content col-12">
                <div className="footer-left col-12 col-t-12 col-d-4">
                    <span>© {currentYear} Stand. All Rights Reserved.</span>
                </div>
                <div className="footer-center col-12 col-t-12 col-d-4">
                    <ul>
                        <li>
                            <a href="https://www.linkedin.com/in/hugo-quintal" target="_blank" rel="noopener noreferrer">
                                Facebook
                            </a>
                        </li>
                        <li>
                            <a href="https://github.com/hugoquintal01" target="_blank" rel="noopener noreferrer">
                                Instagram
                            </a>
                        </li>
                        <li>
                            <a href="https://github.com/hugoquintal01" target="_blank" rel="noopener noreferrer">
                                Whatsapp
                            </a>
                        </li>
                    </ul>
                </div>
                <div className="footer-right col-12 col-t-12 col-d-4">
                    <ul>
                        <li><Link to="/">Ínicio</Link></li>
                        <li><Link to="/quem-somos">Quem Somos</Link></li>
                        <li><Link to="/carros">Carros</Link></li>
                        <li><Link to="/contactos">Contactos</Link></li>
                        <li><Link to="/politica-privacidade">Politica de Privacidade</Link></li>
                        <li><Link to="/politica-privacidade">Politica de Cookies</Link></li>
                    </ul>
                </div>
            </div>
        </section>
    );
}

export default Footer;